import { Bridge } from '@/utils/bridge';
import { isAppEnv } from '@/utils/device';
import constants, { encryptedMarketplaceId } from '@/constants';
import { APP_RUN_ENV } from '@/configs/common';
import { isLoginAuthenticated, isInArray } from '@/utils/common';

const isRequiredToAddToken = option => {
  const { url } = option;
  const noTokenUrls = [
    '/search/getSearchResult',
    '/config/category',
    '/asin/detail',
    '/asin/batch',
    '/brandStore/browseInfo',
    '/content/template',
    '/content/category',
    '/content/widget/popup',
    '/dps/promotion/GetPromotionInfosByPromotionIds',
    '/dps/dealsByIdList',
    '/recommend/asins',
    '/categorys/list',
    '/content/widget/advertising',
    '/asin/getAplusContent',
    '/brandStore/browseInfo',
    '/review/allV1',
    '/review/top',
    '/dps/deals/items',
    '/dps/deals',
    '/content/widget/hotKeys',
    '/content/widget/floatingWindow',
    '/recommend/deals',
    '/content/getPersonalRecommend',
    '/content/setPersonalRecommend'
  ];
  return isInArray(url, noTokenUrls);
};

const isRequiredToAddTokenByLogin = option => {
  const { url } = option;
  const NOT_FORCE_LOGIN_URLS = ['/promotion/getNewCustomerPromotions'];
  return isInArray(url, NOT_FORCE_LOGIN_URLS);
};

const getToken = async env => {
  const { accessToken } = await Bridge.callFnVal('getAccessToken', {});
  return env === APP_RUN_ENV.APP
    ? accessToken
    : sessionStorage.getItem('token') || '';
};

/**
 * setOptions Request options configuration method
 * @param { 'Content-Type': '' } objHeaders
 * @returns
 */
export const setOptions = async (objHeaders, option = { url: '' }) => {
  const options = {
    'Content-Type': 'application/json'
  };
  // header add marketplaceId
  options.marketplaceId = encryptedMarketplaceId;
  options.clientId = constants.CLIENT_ID;
  // token config
  if (isAppEnv()) {
    if (!isRequiredToAddToken(option)) {
      // login need add token, sign out no need add token
      if (isRequiredToAddTokenByLogin(option)) {
        const isLoginStatus = await isLoginAuthenticated(false);
        if (isLoginStatus) {
          options.token = await getToken(APP_RUN_ENV.APP);
        }
      } else {
        options.token = await getToken(APP_RUN_ENV.APP);
      }
    }
  } else {
    // This is for development process
    options.token = await getToken(APP_RUN_ENV.H5);
  }
  return { headers: { ...options, ...objHeaders } };
};

export const setParams = (params = {}) => {
  return { ...params };
};
